import React, { useState, useEffect } from "react";
import { Modal, Form, Button } from "react-bootstrap";

export default function CreateDocumentModal({
  show,
  handleClose,
  handleSave,
  editData,
}) {
  const [form, setForm] = useState({
    deal: "",
    type: "",
    owner: "",
    content: "",
  });

  useEffect(() => {
    if (editData) setForm(editData);
  }, [editData]);

  const deals = ["collins.wiszok", "walter"];
  const types = ["contract", "proposal", "quote"];
  const owners = ["vamsi sai", "prakash", "john"];

  const submit = () => {
    handleSave({
      ...form,
      title: form.type + " Document",
      status: form.type,
    });
  };

  return (
    <>
      <style>{`
        .modal-save {
          background:#ff6a00;
          color:#fff;
        }

        select:focus {
          border-color:#ff6a00 !important;
          box-shadow:0 0 0 0.2rem rgba(255,106,0,0.2);
        }
      `}</style>

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {editData ? "Edit Document" : "Create Document"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Choose Deal</Form.Label>
              <Form.Select
                value={form.deal}
                onChange={(e) =>
                  setForm({ ...form, deal: e.target.value })
                }
              >
                <option>Select</option>
                {deals.map((d) => (
                  <option key={d}>{d}</option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Document Type</Form.Label>
              <Form.Select
                value={form.type}
                onChange={(e) =>
                  setForm({ ...form, type: e.target.value })
                }
              >
                <option>Select</option>
                {types.map((t) => (
                  <option key={t}>{t}</option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Owner</Form.Label>
              <Form.Select
                value={form.owner}
                onChange={(e) =>
                  setForm({ ...form, owner: e.target.value })
                }
              >
                <option>Select</option>
                {owners.map((o) => (
                  <option key={o}>{o}</option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group>
              <Form.Label>Content</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={form.content}
                onChange={(e) =>
                  setForm({ ...form, content: e.target.value })
                }
              />
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="light" onClick={handleClose}>
            Cancel
          </Button>
          <Button className="modal-save" onClick={submit}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}